import React, { useState, useEffect } from "react";
import CartItem from "../../components/CartItem/CartItem";
import "./Cart.css";
import { SkeletonGrid } from "../../components/Skeleton/Skeleton";
import { Link, useNavigate } from "react-router-dom";
// import { toast } from "react-hot-toast";
import { toast } from "react-toastify";

import Loaderdots from "../../components/LoaderDots/Loaderdots";
import NoData from "../../components/NoData/NoData";
import Swal from "sweetalert2";
import { cartEmty } from "../../Assests/Assests";



export const Cart = () => {
  const [cartItems, setCartItems] = useState([]);
  // const [userCartDetails, setUserCartDetails] = useState([])
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
 
  // useEffect(() => {
  //   // Show toast message when the component mounts
  //   toast.info("TRY and BUY is Available For Some Pincodes.", {
  //     position: "top-right",
  //     autoClose: 5000, // Closes after 5 seconds
  //     hideProgressBar: false,
  //     closeOnClick: true,
  //     pauseOnHover: true,
  //     draggable: true,
  //     theme: "colored",
  //     className: "custom-toast",
  //   });
  // }, []);

  useEffect(() => {
    
    const fetchCartItems = async () => {
      try {
        const response = await fetch(
          `https://riymay.com/api/v1/user/cart/`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
          }
        );

        const result = await response.json();

        if( result.message == "email is not verified"){
          try {
            const token = localStorage.getItem("userToken")
            // Call the resend OTP API
            const resendResponse = await fetch("https://riymay.com/api/v1/user/resend/verification/email", {
              method: "POST",
              headers: {
                "Content-Type": "application/json", 
              },
              body: JSON.stringify({token}),
            });  
      
            const resendData = await resendResponse.json();
      
            if (resendData.success) {
              toast.success("✅ OTP resent successfully!", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "custom-toast",
        bodyClassName: "custom-toast-body",
              });
              
              // Delay navigation until after the toast is shown
              setTimeout(() => {
                navigate("/resend-otp");
              }, 3000);
              
            } else {
              setError(resendData.message || "Failed to resend OTP");
              toast.error(resendData.message || "❌ Failed to resend OTP", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                className: "custom-toast",
                bodyClassName: "custom-toast-body",              });
                          }
          } catch (error) {
            setError("An error occurred while resending OTP");
            toast.error("An error occurred while resending OTP", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              className: "custom-toast",
              bodyClassName: "custom-toast-body",            });
            
          }
        }
        if(result.message == "Invalid token" || result.message == "Invalid or expired token"){
          localStorage.removeItem("userToken")
          navigate("/login")
        }
      

        if (!response.ok) {
          
          throw new Error("Failed to fetch cart items");
        }

         
        
        setCartItems(result.cartItems || []);
        // toast.info("TRY and BUY is Available For Some Pincodes.", {
        //   position: "top-right",
        //   autoClose: 5000, // Closes after 5 seconds
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   theme: "colored",
        //   className: "custom-toast",
        // });
      } catch (error) {
        console.error("Error fetching cart items:", error);
      } finally {
        // This clear used to live in a second effect that fetched the Try & Buy
        // pincode list. When that feature was removed from the frontend the
        // effect went with it, and nothing was left to switch `loading` off --
        // so the cart sat in its loading state forever and never rendered a
        // single item. It belongs here, on the fetch it actually describes, and
        // in `finally` so a failed request still releases the page instead of
        // hanging on it.
        setLoading(false);
      }
    };

    fetchCartItems();
    handleDiscountChange()
  }, []);

  // useEffect(() => {
  //   const fetchUser = async() => {
  //     const response  = await fetch(
  //        `https://riymay.com/api/v1/user/getuserdetails`,
  //         {
  //           method: "GET",
  //           headers: {
  //             Authorization: `Bearer ${localStorage.getItem("userToken")}`,
  //             "Content-Type": "application/json",
  //           },
  //         }
  //     )
  //     const result = await response.json();

      // if(result.message == "Invalid token" || result.message == "Invalid or expired token"){
      //   localStorage.removeItem("userToken")
      //   navigate("/login")
      // }
      // if (!response.ok) {
      //   throw new alert("Failed to fetch user data");
      // }

  //       // Extract cart items with coupon details
  //       const updatedCartItems = result.user.cart.map((item) => ({
  //         ...item,
  //         couponCode: item.couponCode || "", 
  //         discountAmount: item.discountAmount || 0, 
  //       }));


  //     setUserCartDetails(updatedCartItems)
  //   }
  //   fetchUser()
  // }, []) 

  // const handleCheckout1 = () => {
  //   if (!enteredPincode) {
  //     toast.error("Please enter a valid pincode.", {
  //       position: "top-right",
  //       autoClose: 3000, // Closes after 3 seconds
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       theme: "colored",
  //       className: "custom-toast",
  //     });
  //     return;
  //   }

    const handleIncrease = async (productId, size, color) => {
    try{
    const makeAPI = await fetch(`https://riymay.com/api/v1/user/cart`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("userToken")}`,
      },
      body: JSON.stringify({ productId, size, color }),
    });
    const responseAPI = await makeAPI.json();
    if (makeAPI.ok) {
      // Let the navbar cart acknowledge the change. No image or rect is sent:
      // the visitor is already looking at the cart, so flying a photo into the
      // icon would be pointless. The listener treats a detail-less event as
      // "react immediately, no flight".
      window.dispatchEvent(new CustomEvent("riymay:cart-changed"));
      console.log(setCartItems, "discount ================")
      setCartItems((prevItems) =>
        prevItems.map((item) =>
          item._id === productId && item.size === size
            ? { ...item, quantity: item.quantity + 1 }
            : item
        )
      );
    }
  }catch(err){
    console.error(err.message);
  }
}

  const handleDecrease = async (productId, size, color) => {
    try {
      const makeAPI = await fetch(`https://riymay.com/api/v1/user/cart`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
        body: JSON.stringify({ productId, size, color }),
      });
      const responseAPI = await makeAPI.json();
      if (makeAPI.ok) {
        setCartItems((prevItems) =>
          prevItems.map((item) =>
            item._id === productId && item.size === size && item.quantity > 1
              ? { ...item, quantity: item.quantity - 1 }
              : item
          )
        );
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleRemove = async (productId, size, color) => {
    try {
      const response = await fetch("https://riymay.com/api/v1/user/cart", {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ productId, size, color }),
      });
      const result = await response.json();
      // console.log(result);
      if (response.ok) {
        localStorage.removeItem(`coupon_${productId}_${size}`);
        setCartItems((prevItems) =>
          prevItems.filter(
            (item) => !(item._id === productId && item.size === size)
          )
        );
      }
    } catch (error) {
      console.error("Error removing item:", error.message);
    }
  };

  
  const handleDiscountChange = (productId, size, discountAmount, couponCode) => {
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item._id === productId && item.size === size
          ? { ...item, discountAmount, couponCode }
          : item
      )
    );
  };

  
  const totalQuantity = cartItems.reduce((acc, item) => acc + item.quantity, 0);
  const totalPrice = cartItems.reduce(
    (acc, item) => acc + item.quantity * (item.price - (item.discountAmount || 0)),
    0
  );


  // const handlePincodeChange = (event) => {
  //   setSelectedPincode(event.target.value);

   
  // };



    // The "Welcome to Cart! TRY & BUY is Available For Some Pincodes Only."
    // toast was removed. Try & Buy is no longer offered on the storefront, so
    // advertising it on every visit to the cart promised something the customer
    // could not then act on. The backend feature is untouched.


  if (loading) return <SkeletonGrid count={3} />
  if (error) return <NoData />;

  const totalDiscount = cartItems.reduce((acc, item) => acc + (item.discountAmount || 0) * item.quantity, 0);

  return (
    <>
    <div className="cart-container">
      <h3 className="cart-page-title">Shopping Cart</h3>

      {cartItems && cartItems.length === 0 ? (
        <div className="cart-empty-state">
          <p className="nodata-label">Your cart is empty</p>
          <p className="nodata-sub">Add something to get started.</p>
          <Link to="/newproduct" className="nodata-btn">Continue Shopping</Link>
        </div>
      ) : (
        <div className="cart-shell">
          <div className="cart-shell-head">
            <h3>Cart</h3>
            <span>{totalQuantity} {totalQuantity === 1 ? "item" : "items"}</span>
          </div>

          {cartItems.map((item) => (
            <CartItem
              key={`${item._id}-${item.size}`}
              item={item}
              onIncrease={() => handleIncrease(item._id, item.size, item.color)}
              onDecrease={() => handleDecrease(item._id, item.size, item.color)}
              onRemove={() => handleRemove(item._id, item.size, item.color)}
              onDiscountChange={handleDiscountChange}
            />
          ))}

          <div className="cart-bar">
<div className="cart-bar-section">
              <div className="cart-bar-label">Items</div>
              <div className="cart-bar-val" key={totalQuantity}>{totalQuantity}</div>
            </div>
            {totalDiscount > 0 && (
              <div className="cart-bar-section">
                <div className="cart-bar-label">Saved</div>
                <div className="cart-bar-val saving" key={totalDiscount}>₹{totalDiscount.toFixed(0)}</div>
              </div>
            )}
            <div className="cart-bar-section">
              <div className="cart-bar-label">Total</div>
              <div className="cart-bar-val" key={totalPrice}>₹{totalPrice.toFixed(0)}</div>
            </div>
            <button className="checkout-button-2" onClick={() => navigate('/shipping-address', { state: { pincode: 'N/A', totalQuantity: totalQuantity, totalPrice: totalPrice} })}>
              Checkout
            </button>
          </div>
        </div>
      )}
    </div>
    </>
  );
};
